/* ============================================================
   REGINA – Warenkorb: Cross-Sell Sofort-Hinzufügen
   assets/section-cart-items.js
   ------------------------------------------------------------
   Fügt ein "Passt perfekt dazu"-Produkt per AJAX hinzu (kein
   Reload) und aktualisiert danach: Artikelliste, Summen in der
   Sidebar, Cross-Sell-Karten selbst und das Warenkorb-Icon im
   Header - über Shopifys Section-Rendering-API.

   WICHTIG (Bugfix 1): Sections innerhalb eines JSON-Templates
   (wie cart.json) bekommen eine automatisch generierte Laufzeit-ID
   (z.B. "template--12345__cart-items"), NICHT den Datei-/Typ-Namen
   ("main-cart-items"). Die echte ID lesen wir zur Laufzeit aus dem
   data-id-Attribut aus. cart-icon-bubble ist die Ausnahme: die ist
   nie in einem JSON-Template eingebettet, ihre ID ist tatsächlich
   der literale Dateiname (bestätigt durch Dawns eigenes cart-items.js).

   WICHTIG (Bugfix 2): Bei Artikelliste UND Zusammenfassung wird
   NUR ".js-contents" ersetzt - NICHT die komplette Section. Ein
   kompletter Ersatz hätte auch Elemente wie das Gutschein-Formular
   (dessen Submit-Listener nur einmal beim Laden angehängt wird) und
   Dawns eigene Mengen-/Entfernen-Logik neu erzeugt und damit deren
   Funktionieren gestört - das war die Ursache für den "Fehler beim
   Aktualisieren"-Hinweis, der nach Cross-Sell-Hinzufügen + späterer
   Mengenänderung auftrat. Exakt derselbe, engere Ausschnitt, den
   auch Dawns eigenes cart-items.js verwendet.

   Event-Delegation auf document statt Listener direkt auf den
   Cross-Sell-Buttons - deren Karten werden komplett ersetzt (dort
   unkritisch, da nur per Event-Delegation gesteuert).
   ============================================================ */
(function () {
  var isAdding = false;

  function getSectionId(elementId) {
    var el = document.getElementById(elementId);
    return el ? el.dataset.id : null;
  }

  // Ersetzt gezielt nur .js-contents innerhalb eines Wrapper-Elements -
  // lässt alles andere (Formulare, Buttons mit eigenen Listenern,
  // Custom Elements) unangetastet.
  function swapJsContents(sections, sectionId, wrapperId) {
    if (!sectionId || !sections[sectionId]) return;
    var doc = new DOMParser().parseFromString(sections[sectionId], 'text/html');
    var freshWrapper = doc.getElementById(wrapperId);
    var liveWrapper = document.getElementById(wrapperId);
    if (!freshWrapper || !liveWrapper) return;
    var fresh = freshWrapper.querySelector('.js-contents');
    var live = liveWrapper.querySelector('.js-contents');
    if (fresh && live) live.innerHTML = fresh.innerHTML;
  }

  // Für Bereiche ohne dauerhaft angehängte Listener (z.B. Cross-Sell,
  // das nur per Event-Delegation auf document gesteuert wird) ist ein
  // kompletter Ersatz unkritisch.
  function swapWhole(sections, sectionId, wrapperId) {
    if (!sectionId || !sections[sectionId]) return;
    var doc = new DOMParser().parseFromString(sections[sectionId], 'text/html');
    var fresh = doc.getElementById(wrapperId);
    var live = document.getElementById(wrapperId);
    if (fresh && live) live.innerHTML = fresh.innerHTML;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cross-add]');
    if (!btn || isAdding || btn.disabled || btn.classList.contains('is-loading')) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    isAdding = true;
    btn.classList.add('is-loading');
    btn.classList.remove('is-success', 'is-error');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) throw new Error((result.data && result.data.description) || 'Fehler');

        btn.classList.remove('is-loading');
        btn.classList.add('is-success');

        var itemsId = getSectionId('main-cart-items');
        var footerId = getSectionId('main-cart-footer');
        var crossId = getSectionId('main-cart-cross-sell');
        var ids = [itemsId, footerId, crossId, 'cart-icon-bubble'].filter(Boolean);

        return fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')) + '&_=' + Date.now(), { cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            swapJsContents(sections, itemsId, 'main-cart-items');
            swapJsContents(sections, footerId, 'main-cart-footer');
            swapWhole(sections, crossId, 'main-cart-cross-sell');

            // Sonderfall Header-Bubble: Ziel ist #cart-icon-bubble im Header,
            // dessen Inhalt aus .shopify-section der Antwort kommt.
            if (sections['cart-icon-bubble']) {
              var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
              var fresh = doc.querySelector('.shopify-section');
              var live = document.getElementById('cart-icon-bubble');
              if (fresh && live) live.innerHTML = fresh.innerHTML;
            }
          });
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        setTimeout(function () { btn.classList.remove('is-error'); }, 2200);
      })
      .finally(function () {
        isAdding = false;
      });
  });
})();
